import React from "react";
import { useFormik } from "formik";
import { CarContracrAddFormValidation } from "./CarContractAddFormValidation";
import CarContracrAddFormFields from "./CarContractAddFormFields";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import {
  MUTATION_ADD_CAR_CONTRACT,
  MUTATION_EDIT_CAR_CONTRACT,
} from "../../../service/ApolloClient/ApolloMutation";
import { withRouter } from "react-router";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import { CAR_CONTRACT_SELECT_ATTACHMENT } from "../../../containers/CarContract/CarContractEditPage";
import CarContractSalePrint from "./CarContractPrint/CarContractSalePrint";
import CarContractPurchasePrint from "./CarContractPrint/CarContractPurchasePrint";
import CarContractInstallmenSalePrint from "./CarContractPrint/CarContractInstallmenSalePrint";

const validationSchema = CarContracrAddFormValidation;

const CarContracrAddForm = (props) => {
  const { data } = props;

  let valuesDefault = {
    document_number: "",
    document_date: null,
    document_type: "",

    seller_id: "",

    buyer_id: "",

    delivery_date: null,
    inspection_center: "",
    inspection_date: null,

    notes: "",
    delivered_items: "",

    buyer_other_delivered_items: "",

    car_type: "",
    car_color: "",
    current_tag: "",
    next_tag: "",
    motor_number: "",
    vin_number: "",
    barcode: "",
    insurance_company: "",
    insurance_id: "",
    insurance_unique_id: "",
    insurance_expire_date: null,
    price: 0,
    price_buy: 0,
    payment_terms: "",
    is_closed: false,
    chassis_number: "",
    manufacture_date: "",
    office: "",
  };

  if (props.isEdit) {
    valuesDefault = {
      ...valuesDefault,
      ...data,
      is_closed: props.data.is_closed == "1",
      inspection_date: data.inspection_date ? data.inspection_date : null,
    };
  }

  const formikData = useFormik({
    initialValues: valuesDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;
      newValue.document_date = checkDateInput(values.document_date);
      newValue.delivery_date = checkDateInput(values.delivery_date);
      newValue.insurance_expire_date = checkDateInput(
        values.insurance_expire_date,
      );
      newValue.inspection_date = checkDateInput(values.inspection_date);

      newValue.delivered_items = values.delivered_items;
      submitHandle(newValue);
    },
  });

  const submitHandle = (values) => {
    setLoading(true);
    client
      .mutate({
        mutation: props.isEdit
          ? MUTATION_EDIT_CAR_CONTRACT
          : MUTATION_ADD_CAR_CONTRACT,
        variables: values,
      })
      .then((result) => {
        let carContract = props.isEdit
          ? result.data.editCarContract
          : result.data.addCarContract;
        if (carContract === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast("درخواست با موفقیت انجام شد ");
        }
        setLoading(false);
        props.history.push("/car-contract/edit/" + carContract.id);
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);

  return (
    <Box mt={2}>
      <Card>
        <CardContent>
          <Box ml={2} mb={2} display={"flex"}>
            {/*<Box>*/}
            {/*    <PersonAdd/>*/}
            {/*</Box>*/}

            <Box flexGrow={1} ml={1}>
              <Typography variant={"h5"} align={"left"}>
                {props.isEdit
                  ? "ویرایش معامله ماشین " + " " + props.data.id
                  : "  افزودن معامله ماشین"}
              </Typography>
            </Box>
            <Box style={{ textAlign: "left", float: "right" }} display={"flex"}>
              {props.isEdit ? (
                <ButtonGroup style={{ float: "right" }}>
                  <Button
                    color={"primary"}
                    onClick={(e) =>
                      props.handleSelectPage(CAR_CONTRACT_SELECT_ATTACHMENT)
                    }
                  >
                    ضمیمه ها
                  </Button>

                  <Button
                    color={"secondary"}
                    onClick={(e) =>
                      props.history.push(
                        "/cheque/car-contract/" + props.data.id,
                      )
                    }
                  >
                    چک ها
                  </Button>

                  {valuesDefault.document_type === "purchase" ? (
                    <CarContractPurchasePrint data={valuesDefault} />
                  ) : valuesDefault.document_type === "sale" ? (
                    <CarContractSalePrint data={valuesDefault} />
                  ) : valuesDefault.document_type === "installment_sale" ? (
                    <CarContractInstallmenSalePrint data={valuesDefault} />
                  ) : (
                    ""
                  )}
                </ButtonGroup>
              ) : null}
            </Box>
          </Box>
          <CarContracrAddFormFields
            loading={loading}
            isEdit={props.isEdit}
            {...formikData}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(CarContracrAddForm);
